import axios from 'axios'
import './common'

export default {
    create: (data) => axios.post(`/feedbacks`, data),
}